import appStorage from "@Context/storage";
import StorageKeys from "@Enums/StorageKeys";

export type DecisionInsightsRating = "up" | "down";

interface DecisionInsightsRatingParams {
  cognitiveResultId: number;
  userId?: string | null;
}

type StoredRatings = Record<string, DecisionInsightsRating>;

const buildRatingKey = ({ cognitiveResultId, userId }: DecisionInsightsRatingParams) => `${userId || "anonymous"}:${cognitiveResultId}`;

const getStoredRatings = (): StoredRatings => appStorage.get({ key: StorageKeys.DECISION_INSIGHTS_RATINGS }) ?? {};

export const loadDecisionInsightsRating = (params: DecisionInsightsRatingParams): DecisionInsightsRating | null => {
  if (!params.cognitiveResultId) {
    return null;
  }

  try {
    const rating = getStoredRatings()[buildRatingKey(params)];
    return rating === "up" || rating === "down" ? rating : null;
  } catch (error) {
    console.warn("Failed to load decision insights rating from storage:", error);
    return null;
  }
};

export const saveDecisionInsightsRating = (params: DecisionInsightsRatingParams, rating: DecisionInsightsRating | null): void => {
  if (!params.cognitiveResultId) {
    return;
  }

  try {
    const ratings = getStoredRatings();
    const ratingKey = buildRatingKey(params);

    if (rating) {
      ratings[ratingKey] = rating;
    } else {
      delete ratings[ratingKey];
    }

    appStorage.set({
      key: StorageKeys.DECISION_INSIGHTS_RATINGS,
      data: ratings,
    });
  } catch (error) {
    console.warn("Failed to save decision insights rating to storage:", error);
  }
};
